import { axiosInstance, overrideHeader } from '.';

export const createSubscriptionRequest = data => {
  overrideHeader();
  return axiosInstance.post(`/cms/subscribe`, data);
};
